import React from "react";
import { User, Mail, Phone, FileText, Calendar, CheckCircle, Clock, Eye } from "lucide-react";

const statusConfig = {
  submitted: { label: "Przeslana", color: "bg-amber-100 text-amber-700", icon: Clock },
  reviewed: { label: "Przejrzana", color: "bg-blue-100 text-blue-700", icon: Eye },
  approved: { label: "Zatwierdzona", color: "bg-green-100 text-green-700", icon: CheckCircle },
};

const SelectionViewer = ({ selection, photos = [], onStatusChange, baseUrl = "" }) => {
  if (!selection) return null;

  const status = statusConfig[selection.status] || statusConfig.submitted;
  const StatusIcon = status.icon;

  const selectedPhotos = photos.filter((p) => selection.selected_photo_ids?.includes(p.id));

  return (
    <div className="space-y-4">
      {/* Client info header */}
      <div className="bg-white rounded-xl border border-slate-200 p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-slate-900 font-medium">
              <User className="w-4 h-4" /> {selection.client_name}
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Mail className="w-3.5 h-3.5" /> {selection.client_email}
            </div>
            {selection.client_phone && (
              <div className="flex items-center gap-2 text-sm text-slate-500">
                <Phone className="w-3.5 h-3.5" /> {selection.client_phone}
              </div>
            )}
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Calendar className="w-3.5 h-3.5" /> {new Date(selection.created_at).toLocaleDateString("pl-PL")}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className={`px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${status.color}`}>
              <StatusIcon className="w-3.5 h-3.5" /> {status.label}
            </span>
          </div>
        </div>
        {selection.notes && (
          <div className="flex items-start gap-2 text-sm text-slate-600 bg-slate-50 rounded-lg p-3">
            <FileText className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <p>{selection.notes}</p>
          </div>
        )}
        <div className="flex gap-2 mt-3">
          {selection.status !== "reviewed" && (
            <button
              onClick={() => onStatusChange?.(selection.id, "reviewed")}
              className="text-sm px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 font-medium"
            >
              Oznacz jako przejrzana
            </button>
          )}
          {selection.status !== "approved" && (
            <button
              onClick={() => onStatusChange?.(selection.id, "approved")}
              className="text-sm px-3 py-1.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 font-medium"
            >
              Zatwierdz
            </button>
          )}
        </div>
      </div>

      {/* Selected photos grid */}
      <div>
        <h4 className="text-sm font-medium text-slate-700 mb-2">
          Wybrane zdjecia ({selectedPhotos.length})
        </h4>
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
          {selectedPhotos.map((photo) => {
            const photoUrl = photo.url?.startsWith("http") ? photo.url : `${baseUrl}${photo.url}`;
            return (
              <div key={photo.id} className="relative aspect-square rounded-lg overflow-hidden bg-slate-100">
                <img src={photoUrl} alt={photo.filename} className="w-full h-full object-cover" loading="lazy" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SelectionViewer;
